import { type IPromo } from '../../../types/promos';

export function getAuthorLabel(promo: IPromo): string | null {
  const cianMortgage = promo.promoType === 'cianMortgage';

  if (cianMortgage) {
    return null;
  }

  return promo.isFromBuilder ? 'Застройщик' : 'Представитель застройщика';
}
